module.exports = __webpack_public_path__ + "static/img/Downloader.la-65dcdeef57626.7d24b2ad.jpg";